<template>
    <h1>Bienvenid@ {{email}}</h1>
    <br>
    <h3 style="text-align: left;">Cotizaciones por mes</h3>

     <div style="text-align:right;">
          
          <button type="button" class=" btn btn-warning btn-sm" @click="pdfInformeTrimestral()">Informe Trimestral</button>

         </div>
<br>
    <div class="card ">
        <div class="card-body">
    <div id="timeline-chart"></div>
    </div>
</div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  import ApexCharts from 'apexcharts';
   
    import Swal from 'sweetalert2';
  export default {
    data(){
        return{
            email:localStorage.getItem('email')
        }
    },
    methods: {
      pdfInformeTrimestral(){
          
    
          axios({
            method: 'post',
            url: this.$rutaServer+'generate_pdf_informe_trimestral',
            responseType: 'blob', // Aquí es donde se especifica el tipo de respuesta
            
          })
          .then(response => {
        
          if (response.status === 200) {
            // Crear un objeto Blob a partir de la respuesta
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'actainspeccion.pdf'); // Nombre del archivo

            // Agregar y hacer clic en el enlace para iniciar la descarga
            document.body.appendChild(link);
            link.click();

            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
        }
        })
        .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error al generar el PDF', 'error');
            console.error('Error al descargar el PDF:', error);
        });
        },
    },
    setup() {
      const grafica = ref(null);
  
      const fetchData = async () => {
        try {
          const response = await axios.post('https://backsarei.seguridadeninspeccion.com/api/obtenerDatosPorMes');
          const apiData = response.data;
  
          // Preparar series y categorías para ApexCharts
          const series = [];
          const categories = new Set(); // Usamos un Set para evitar duplicados de categorías
  
          // Nombres de los meses en español (puedes ajustar según tu idioma)
          const monthNames = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
            'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
          ];
  
          // Iterar sobre los datos obtenidos del API
          apiData.forEach(item => {
            const year = item.year;
            const month = item.month;
            const count = item.count;
  
            // Agregar el conteo al arreglo de datos de la serie
            if (!series[year]) {
              series[year] = {
                name: year,
                data: []
              };
            }
            series[year].data.push(count);
  
            // Construir la etiqueta del eje X con el formato mes/año
            categories.add(`${monthNames[month - 1]}`); // Usamos month - 1 porque los meses son 1-indexed
          });
  
          // Convertir el Set de categorías a un arreglo
          const categoriesArray = Array.from(categories);
  
          // Configuración de la gráfica con los datos procesados
          const options = {
            series: Object.values(series), // Convertir el objeto de series en un arreglo
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: categoriesArray,
              labels: {
                rotate: -45,
                rotateAlways: true
              }
            },
            yaxis: {
              title: {
                text: 'Conteo de Cotizaciones'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " cotizaciones";
                }
              }
            }
          };
  
          // Inicializar y renderizar la gráfica
          grafica.value = new ApexCharts(document.querySelector("#timeline-chart"), options);
          grafica.value.render();
        } catch (error) {
          console.error('Error al obtener los datos:', error);
        }
      };
  
      onMounted(fetchData);
  
      return {
        grafica
      };
    }
  };
  </script>
  